import * as React from "react";
import { cn } from "@/shared/lib/utils";

import ArrowIconBlack from "@/assets/icons/arrow/linkBlack.svg?react";
import ArrowIconWhite from "@/assets/icons/arrow/linkWhite.svg?react";

interface ICalculatorButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string
}

const CalculatorButton = React.forwardRef<HTMLButtonElement, ICalculatorButtonProps>(
    ({children, className, ...props }, ref) => {

        const [pressed, setPressed] = React.useState<boolean>(false);
        const [hovered, setHovered] = React.useState<boolean>(false);

        return (
            <button
                ref={ref}
                className={cn(
                    "bg-light-blue h-[48px] pl-[16px] pr-[4px] font-manrope text-[14px] md:text-[16px] font-medium rounded-[20px] flex justify-between items-center shadow-glass",
                    className,
                    pressed && "bg-white-80"
                )}
                {...props}
                onMouseDown={()=>setPressed(true)}
                onMouseUp={()=>setPressed(false)}
                onMouseEnter={()=>setHovered(true)}
                onMouseLeave={()=>{setPressed(false); setHovered(false)}}
                
                onTouchStart={()=>setPressed(true)}
                onTouchEnd={()=>setPressed(false)}
            >

                {children}

                <div className={cn(
                    "h-[40px] w-[40px] rounded-full flex justify-center items-center transition-all ease-linear duration-200",
                    "bg-white-50",
                    hovered && "bg-blue-70",
                    pressed && "bg-white-50 shadow-glass"
                )}>
                    {hovered && !pressed ? (
                        <ArrowIconWhite className="w-[14px] h-[14px] transition-all"/>
                    ) : (
                        <ArrowIconBlack className="w-[14px] h-[14px] transition-all"/>
                    )}
                </div>
            </button>
        );
    }
);

CalculatorButton.displayName = "CalculatorButton";

export default CalculatorButton;